import { ifAuthenticated, mustBeAdmin } from "../util/auth";

const Report = () => import("../components/content/report/report");
const ReportSummary = () =>
  import("../components/content/report/reportSummary");

export const reportRoute = {
  path: "/reports",
  component: Report,
  // beforeEnter: ifAuthenticated
  beforeEnter: mustBeAdmin
};

export const reportSummaryRoute = {
  path: "/report-summary/:uuid",
  name: "reportSummary",
  component: ReportSummary,
  // beforeEnter: ifAuthenticated
  beforeEnter: mustBeAdmin
};
